import React, { useState } from "react";
import EntryColor from "../container/EntryColor";
import FlatViewOmni from "./FlatViewOmni";
import ModalOpenBetsChart from "../modals/ModalOpenBetsChart";
import SwitchActiveBetsColum from "../utilities/SwitchActiveBetsColum";
import ButtonOpenBetsBetType from "../utilities/ButtonOpenBetsBetType";

const Omni = ({
  entries,
  charts,
  otherViews,
  getOpenBetsChartModal,
  openBetsChartInfo,
  setOpenBetsChartInfo,
  userInfo,
  idOmni,
  raceID,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  getCharts,
}) => {
  const [showBetsColumnOmni, setShowBetsColumnOmni] = useState(false);
  var totalEntries = entries.length + 1;
  var omniArray = new Array(totalEntries);

  //Bucle para meter en cada posición otros array de 10
  for (var i = 0; i < totalEntries; i++) {
    omniArray[i] = new Array(totalEntries);
  }

  entries.forEach((entry, k) => {
    omniArray[0][k + 1] = entry.EntryNum;
    omniArray[k + 1][0] = entry.EntryNum;
  });

  charts.forEach((chart, i) => {
    let selections = chart.Selections.split(",");
    omniArray[selections[0]][selections[1]] = String(
      chart.Amount + "," + chart.BetCount
    );
  });

  //Recorrer chart y sacar los selection con split y meterlos en new array
  var tableContent = [],
    headers = [],
    tdOmni = [],
    tdFirstLeg = [];

  for (let i = 0; i < omniArray.length; i++) {
    //columnas
    for (let j = 0; j < omniArray[i].length; j++) {
      //filas
      let colorHeader;

      if (i === 0) {
        let colsPan;
        if (i === 0 && j !== 0) {
          colsPan = 2;
          colorHeader = "#00334d";
        }
        headers.push(
          <th
            colSpan={showBetsColumnOmni ? colsPan : 1}
            style={{
              verticalAlign: "middle",
              backgroundColor: colorHeader,
            }}
            key={j}
          >
            <EntryColor
              entryNum={omniArray[i][j]}
              saddleNum={omniArray[i][j]}
            />
          </th>
        );
      }

      if (j !== 0 && i !== 0) {
        //This variable (selections) is used as a parameter to query getOpenBetsChart
        let selections = i + "," + j.toString();

        let amount = omniArray[i][j];
        if (amount) {
          let values = amount.split(",");
          tdOmni.push(
            <React.Fragment key={j}>
              <td
                style={{ verticalAlign: "middle", fontWeight: "bold" }}
                key={"amount" + j}
              >
                ${parseFloat(values[0]).toFixed(2)}
              </td>
              {showBetsColumnOmni && (
                <td
                  style={{ verticalAlign: "middle" }}
                  key={"cantBets" + j}
                  className="cantBets"
                  data-toggle="modal"
                  data-target="#openBetsChartModal"
                  onClick={() => getOpenBetsChartModal(idOmni, selections)}
                >
                  {values[1]}
                </td>
              )}
            </React.Fragment>
          );
        } else if (j === i) {
          tdOmni.push(
            <td
              colSpan={showBetsColumnOmni ? 2 : 1}
              style={{ backgroundColor: "#dee2e6" }}
              key={j}
            ></td>
          );
        } else {
          tdOmni.push(
            <td
              colSpan={showBetsColumnOmni ? 2 : 1}
              style={{ verticalAlign: "middle" }}
              key={j}
            ></td>
          );
        }
      }

      if (j === 0 && i !== 0) {
        tdFirstLeg.push(
          <td key={j} className="firstLegTD">
            {
              <EntryColor
                entryNum={omniArray[i][j]}
                saddleNum={omniArray[i][j]}
              />
            }
          </td>
        );
      }
    }
    tableContent.push(
      <tr key={"tr"}>
        {tdFirstLeg}
        {tdOmni}
      </tr>
    );

    tdOmni = [];
    tdFirstLeg = [];
  }

  return (
    <>
      <ModalOpenBetsChart
        openBetsChartInfo={openBetsChartInfo}
        setOpenBetsChartInfo={setOpenBetsChartInfo}
        userInfo={userInfo}
        wagerTypeId={idOmni}
        voidTickets={voidTickets}
        callTicketVoidListFrom={callTicketVoidListFrom}
        selectedTicketsVoidScore={selectedTicketsVoidScore}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        selectAllTickets={selectAllTickets}
        setSelectAllTickets={setSelectAllTickets}
        scoreTickets={scoreTickets}
        setCallTicketVoidListFrom={setCallTicketVoidListFrom}
        getCharts={getCharts}
      />
      <div className="row">
        <div className="col-sm-6">
          <SwitchActiveBetsColum
            showBetsColumn={showBetsColumnOmni}
            setShowBetsColumn={setShowBetsColumnOmni}
          />
        </div>
        <div className="col-sm-6" style={{ textAlign: "right" }}>
          <ButtonOpenBetsBetType
            ticketType={idOmni}
            raceID={raceID}
            userInfo={userInfo}
            openBetsChartInfo={openBetsChartInfo}
            setOpenBetsChartInfo={setOpenBetsChartInfo}
          />
        </div>
      </div>

      {!otherViews ? (
        <>
          <div className="mb-2" style={{ textAlign: "right" }}>
            <span
              className="badge rounded-circle"
              style={{ backgroundColor: "#79a6d2", color: "transparent" }}
            >
              ..
            </span>
            <span className="mr-3 ml-1">First Leg</span>
            <span
              className="badge rounded-circle"
              style={{ backgroundColor: "#00334d", color: "transparent" }}
            >
              ..
            </span>
            <span className="ml-1">Second Leg</span>
          </div>
          <div className="scrollHorizontal">
            <table className="table table-bordered table-sm">
              <thead className="theadFixed">
                <tr className="text-center">{headers}</tr>
              </thead>
              <tbody className="table-sm text-center table-bordered">
                {tableContent}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <FlatViewOmni
          charts={charts}
          getOpenBetsChartModal={getOpenBetsChartModal}
          idOmni={idOmni}
          showBetsColumnOmni={showBetsColumnOmni}
        />
      )}
    </>
  );
};

export default Omni;
